// src/components/shared/formatters.js
// Gemeinsame Formatierungsfunktionen - deutsches Format für Datum und Geldbeträge.
// Dokumentklassen-unabhängig (kein Rechnung-Wissen), daher hier statt bei einer
// bestimmten Dokumentklasse.
const currencyFormatter = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export function formatCurrency(value) {
    if (value === null || value === undefined || value === '') return '–';
    const num = Number(value);
    if (Number.isNaN(num)) return String(value);
    return currencyFormatter.format(num);
}

export function parseGermanNumber(text) {
    if (text === null || text === undefined) return null;
    const trimmed = String(text).trim();
    if (trimmed === '') return null;
    // Tausenderpunkte entfernen, Komma als Dezimaltrennzeichen interpretieren (deutsches Format).
    const normalisiert = trimmed.replace(/\./g, '').replace(',', '.');
    const num = Number(normalisiert);
    return Number.isNaN(num) ? null : num;
}

export function formatDate(value) {
    if (!value) return '–';
    // Backend/Extraktion liefert "yyyy-MM-dd" (siehe Rechnung.cs / RechnungsdatumDatetime).
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return String(value); // unbekanntes Format unverändert anzeigen statt zu raten
    const [, year, month, day] = match;
    return `${day}.${month}.${year}`;
}

export function formatMwst(value) {
    if (value === null || value === undefined) return '–';
    return Object.entries(value)
        .map(([satz, betrag]) => `${satz}%: ${formatCurrency(betrag)}`)
        .join(', ');
}